import styled from "@emotion/styled";
import { Box, CircularProgress, Modal, Typography } from "@mui/material";

export const Container = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Label = styled(Typography)`
  color: #fff;
  font-size: 16px;
  margin-top: 24px;
  font-weight: bold;
`;

export const Loader = styled(CircularProgress)`
  color: #fff;
`;
